import { WebPlugin } from '@capacitor/core';
export class NetWorkWeb extends WebPlugin {
    async getIpInfo() {
        return { ip: '--', ipv4: '--', ipv6: '--' };
    }
    async connect(options) {
        console.log('Web connect', options);
    }
    async send(options) {
        console.log('Web send', options);
    }
    onData(callback) {
        // Web端可用setTimeout模拟接收数据
        setTimeout(() => callback({ msg: '模拟数据' }), 1000);
    }
    async disconnect() {
        console.log('Web disconnect');
    }
}
//# sourceMappingURL=web.js.map